import { isUserHasKey } from '../../GlobalFunctions';
import TextInput from '../../components/TextInput';
import styles from './AddStudents.module.scss';

interface FormValues {
  [key: string]: string;
}

interface Props {
  values: FormValues;
}

const AddMultipleStudents = ({ values }: Props): JSX.Element => {
  const { studentName, password, email, ...valuesToMap } = values;
  const valuesToMapArray = Object.keys(valuesToMap);

  // Group fields by student index
  const studentGroups: { [key: number]: { name: string; password: string; email: string } } = {};

  valuesToMapArray.forEach((fieldName) => {
    const match = fieldName.match(/\d+$/);
    if (match) {
      const index = parseInt(match[0]);
      if (!studentGroups[index]) {
        studentGroups[index] = { name: '', password: '', email: '' };
      }

      if (fieldName.includes('studentName')) {
        studentGroups[index].name = fieldName;
      } else if (fieldName.includes('password')) {
        studentGroups[index].password = fieldName;
      } else if (fieldName.includes('email')) {
        studentGroups[index].email = fieldName;
      }
    }
  });

  return (
    <div className={styles.multiInputRows}>
      {Object.entries(studentGroups).map(([index, fields]) => (
        <div key={index} className={styles.studentGroup}>
          <h4 className={styles.studentGroupTitle}>Student {parseInt(index) + 1}</h4>
          <TextInput
            label='Student Name'
            name={fields.name}
            type='text'
            placeholder=''
            disabled={isUserHasKey('KEY_MANAGE_STUDENTS') === null ? true : !isUserHasKey('KEY_MANAGE_STUDENTS')}
            required
          />
          <TextInput
            label='Password'
            name={fields.password}
            type='text'
            placeholder=''
            disabled={isUserHasKey('KEY_MANAGE_STUDENTS') === null ? true : !isUserHasKey('KEY_MANAGE_STUDENTS')}
          />
          <TextInput
            label='School Email Address'
            name={fields.email}
            type='email'
            placeholder=''
            disabled={isUserHasKey('KEY_MANAGE_STUDENTS') === null ? true : !isUserHasKey('KEY_MANAGE_STUDENTS')}
          />
        </div>
      ))}
    </div>
  );
};

export default AddMultipleStudents;
